import { render, staticRenderFns } from "./LuckyPack.vue?vue&type=template&id=86aaf436&scoped=true"
import script from "./LuckyPack.vue?vue&type=script&lang=js"
export * from "./LuckyPack.vue?vue&type=script&lang=js"
import style0 from "./LuckyPack.vue?vue&type=style&index=0&id=86aaf436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aaf436",
  null
  
)

export default component.exports